<template>
  <div class="edit-btn-wrap mt-30">
    <slot name="before" />
    <button
      class="btn btn_outline btn_lower"
      :style="`margin-right: ${marginRight}`"
      type="button"
      @click.prevent="onBtnCancelClick"
    >
      <span>
        {{ btnCancel }}
      </span>
    </button>
    <button
      class="btn btn_dark btn_lower"
      type="submit"
      :disabled="disabledSave"
      @click="$emit('submitClick', $event)"
    >
      <span>
        {{ btnSave }}
      </span>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'ButtonsBottom',
    props: {
      btnCancel: {
        type: String,
        default() {
          return this.$t('btn.cancel')
        },
      },
      btnSave: {
        type: String,
        default() {
          return this.$t('btn.save')
        },
      },
      preventClose: {
        type: Boolean,
        default: false,
      },
      marginRight: {
        type: String,
        default: '52px',
      },
      disabledSave: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      onBtnCancelClick() {
        if (!this.preventClose) {
          $.magnificPopup.close()
        }
        this.$emit('cancelClick')
      },
    },
  }
</script>
